import jquery from 'jquery';

export default function() {
  var result = jquery.Deferred();

  jquery.post('/client_account/exit.json')
    .done(function() {
      result.resolve({ logout: true });
    })
    .fail(function() {
      console.log('ajaxShop: Shop: client: logout: fail');
      result.reject({ logout: false });
    });

  return result.promise();
}
